import { observer } from 'mobx-react-lite'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ConfirmBidPopup from './ConfirmBidPopup'
import { useStore } from '../../../app/stores/store'
import { currencyValue, formatCurrency } from '../muiStyle/muiStyle'

function AuctionBuyNow() {
  const { bidsStore, userStore } = useStore()
  const { auctionDetails } = bidsStore
  const { id } = useParams()
  const completed = new Date() > new Date(auctionDetails?.deadline as Date)
  const [loadingBtn, setLoadingBtn] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const { t } = useTranslation()

  if (completed) return <></>

  const openBuyNow = () => {
    let userSolvency
    if (auctionDetails?.attachment) {
      userSolvency = auctionDetails?.solvencyAttachment?.find(
        (solvency) => solvency.user!.userId === userStore.user!.id,
      )
    }
    if (!userStore.isLoggedIn) {
      toast.error(t('err_login'))
    } else if (auctionDetails?.status === 2 || completed) {
      toast.error(t('err_ended'))
    } else if (userSolvency?.valid !== 2 && auctionDetails?.attachment) {
      toast.error(t('err_solvency'))
    } else {
      setShowConfirm(true)
    }
  }

  const handleBuyNow = () => {
    setLoadingBtn(true)
    bidsStore.handleBuyNow({ biddingId: id }).finally(() => {
      setShowConfirm(false)
      setLoadingBtn(false)
    })
  }

  const currencyName = currencyValue.find((item) => item.value === auctionDetails?.post?.currency)
    ?.name

  return (
    <>
      {auctionDetails?.post?.type === 1 && (
        <div>
          <h4 className='fw-bold mb-3'>{t('purchase_auction')}: </h4>
          <p className='mb-3'>
            {t('purchase_txt')}:{' '}
            <strong>{`${currencyName} ${formatCurrency(auctionDetails.post?.price)}`}</strong>
          </p>

          <button
            className='auction-details-solvency-review-btn mt-0'
            disabled={loadingBtn}
            onClick={openBuyNow}
          >
            {t('buy_now')}
            <i className='ms-2 fa-solid fa-share' />
          </button>
          <hr className='auction-separator-line mb-3 mt-4' />
        </div>
      )}

      {/* Auction Cofirm Buy Now Modal */}
      <Modal size='lg' centered show={showConfirm} onHide={() => setShowConfirm(false)}>
        <ConfirmBidPopup
          handleClose={() => setShowConfirm(false)}
          handleSubmit={handleBuyNow}
          loadingBtn={loadingBtn}
          title={auctionDetails?.post?.title as string}
          price={auctionDetails?.post?.price as number}
          buyNow
        />
      </Modal>
    </>
  )
}
export default observer(AuctionBuyNow)
